export default __webpack_public_path__ + "static/alawwal-bank-banner-mobile-c871542e3e5d60ec72b140b84e083fdc.jpg";